import { useUIStore } from '../stores/uiStore'
import type { IAppContext } from '../services/appContext'
import type { IRogue } from '../services/RogueTypes'
import { gte } from '@/js/helpers/version-compare'

export const ROGUE_APP_SPA_URL_PREFIX = '/rg-app/'
export const ROGUE_APP_PARAM = '__rogueApp'
export const ROGUE_APP_VERSION_PARAM = '__rogueAppVersion'
export const ROGUE_APP_TAB_PARAM = '__rogueAppTab'
export const DEVICE_PLATFORM_PARAM_SNAKECASE = 'device_platform'
export const DEVICE_PLATFORM_PARAM_CAMELCASE = 'devicePlatform'
export const DEVICE_UID_PARAM_CAMELCASE = 'deviceUid'

/**
 * App's query params
 * This params should be excluded from any website feature that uses url query params
 * to store some needed data.
 */
export const appQueryParams = [
  ROGUE_APP_PARAM,
  ROGUE_APP_VERSION_PARAM,
  ROGUE_APP_TAB_PARAM,
  'device_uuid',
  DEVICE_UID_PARAM_CAMELCASE,
  DEVICE_PLATFORM_PARAM_SNAKECASE,
  DEVICE_PLATFORM_PARAM_CAMELCASE,
  'invoke_iab_rapidpurchase',
  'oauth_token',
  'oauth_token_secret',
  'showTabs',
  'show_tabs',
]

export const isApp = (context: IAppContext, version: string = '') => {
  if (!context) {
    return false
  }

  if (version.length === 0) {
    return true
  }

  if (context.version) {
    return gte(context.version, version)
  }

  return false
}

export const getMessageContext = (context: IAppContext) => (context.platform === 'android' ? document : window)

// Query fragment to append to `href` so a full page load keeps the app context. Joins with
// `&` when the href already has a query so its own params are not corrupted.
export const getAppRequestString = (context: IAppContext | null, href = '') => (
  context
    ? `${href.includes('?') ? '&' : '?'}${ROGUE_APP_PARAM}=1&${ROGUE_APP_VERSION_PARAM}=${context.version}&${DEVICE_PLATFORM_PARAM_CAMELCASE}=${context.platform}`
    : ''
)

export const canSkipRefresh = (rogue: IRogue, checkBackground = true) => {
  // don't skip if we're not in the app
  if (!rogue.appContext) {
    return false
  }
  // skip if we're in the app tab view
  if (rogue.appContext.tab) {
    return true
  }
  // make a decision to skip if we allowed to do so in background
  if (checkBackground) {
    const uiStore = useUIStore(rogue.pinia)

    return uiStore.appIsNotActive
  }

  return false
}
